import { render } from "./CajaCierre.vue?vue&type=template&id=5953188b&scoped=true"
import script from "./CajaCierre.vue?vue&type=script&lang=js"
export * from "./CajaCierre.vue?vue&type=script&lang=js"

import "./CajaCierre.vue?vue&type=style&index=0&id=5953188b&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\frontend_zapi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5953188b"]])

export default __exports__